module.exports = __webpack_public_path__ + "img/lx.214e6596.svg";